import { render, staticRenderFns } from "./XCheckboxWrapper.vue?vue&type=template&id=63f26158"
import script from "./XCheckboxWrapper.vue?vue&type=script&lang=js"
export * from "./XCheckboxWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports